import React from "react";
import { Alert } from "antd";

const ErrorAlert = ({ errorData, style, message }) => {
  return (
    <>
      {errorData && errorData.detail ? (
        <Alert
          className="error-alert"
          message={errorData.detail}
          type="error"
          style={{ ...style }}
        />
      ) : (
        message && (
          <Alert
            className="error-alert"
            message={message}
            type="error"
            style={{ ...style }}
          />
        )
      )}
    </>
  );
};

export default ErrorAlert;
